<template>
	<td :class="`c-list-item ${cssClasses}`">
		<template v-if="variant === 'custom'">
			<div v-html="value"></div>
		</template>
		<template v-else-if="variant === 'checkbox'">
			<vue-input :label="label" :input-id="value" :name="name" type="checkbox" ref="listItemCheckbox"></vue-input>
		</template>
		<template v-else-if="variant === 'router-link'">
			<router-link :to="value">{{label}}</router-link>
		</template>
		<template v-else>
			<span class="c-list-item__label">{{label}}</span>
			<p class="t-text-style-epsilon" v-html="value"></p>
		</template>
	</td>
</template>

<script>
import VueInput from '@/components/vue-components/vue-input/VueInput.vue';

export default {
	name: 'ListItem',
	components: {
		VueInput
	},
    props: {
		variant: {
			type: String,
			default: 'label-value'
		},
		label: {
			type: String,
			required: false
		},
		value: {
			type: String,
			required: false
		},
		name: {
			type: String,
			required: false
		},
		cssClasses: {
			type: String,
			default: 'c-list-item--default'
		}
	}
}
</script>
